<div [attr.data-cy]="'page-forbidden-view'" class="d-flex align-items-center h-100">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-auto">
        <h1 class="display-3">403</h1>
      </div>
      <div class="col-md-auto">
        <h4 class="pt-3">{{ (title ? title : 'route.forbidden.title') | translate }}</h4>
        <p *ngIf="message" [innerHtml]="message | translate"></p>
        <p>
          <a routerLink="/dashboard" nkButton color="secondary" size="lg"
            ><i class="fa fa-home me-2"></i> {{ 'route.forbidden.link' | translate }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
